<!--
 * @description: 
 * @author: Jason Wong
 * @since: 2024-07-11 10:32:25
-->
<template>
  <ve-page :full="true" class="page--index" ref="pageIndexArea">
    <template v-for="widget in widgits">
      <component :is="widget.type" :key="widget.id"></component>
    </template>
  </ve-page>
</template>

<script>
import parser from "./widgets/parser";

import { getWidgetTemplate } from "./widgets/roleWidgetTemplateProvider";
export default {
  data() {
    return {
      widgits: [],
    };
  },
  methods: {
    _loadWidgets(roles) {
      console.log("#_# loadWidgets");
      const widgetTemplate = getWidgetTemplate(roles);

      // let loading = this.$$loading("正在加载中，请耐心等待..."
      // , {
      //       target: this.$refs.pageIndexArea ? this.$refs.pageIndexArea.$el : null,
      //     }
      // );
      console.log(">>>>>>>>>>>>>>>widgetTemplate", widgetTemplate);
      parser
        .parse(widgetTemplate, {})
        .then((data) => {
          console.log(">>>>>>>>>>>>>>>data", data);
          this.widgits = data;
          // if(loading) loading.close();
        })
        .catch((err) => {
          this.$$error(err);
        });
    },
  },
  mounted() {
    const roles = this.$store.state.user.roleList;
    console.log("roles", roles);
    this._loadWidgets(roles);
  },
};
</script>

<style lang="scss">
.page--index {
  background: rgb(228, 227, 239);
  padding: 0;
  border: unset;
  height: 100%;
}
</style>
